const acgRoutes = [
  {
    title: 'Phase 1',
    fullTitle: 'Automated Campaigns Generation - Phase 1',
    icon: 'looks_one',
    titleIcon: true,
    path: '/acg/phase-1',
  },
  {
    title: 'Phase 2',
    fullTitle: 'Automated Campaigns Generation - Phase 2',
    icon: 'looks_two',
    titleIcon: true,
    path: '/acg/phase-2',
  },
  {
    title: 'Phase 3',
    fullTitle: 'Automated Campaigns Generation - Phase 3',
    icon: 'looks_3',
    titleIcon: true,
    path: '/acg/phase-3',
  },
  {
    title: 'Phase 4',
    fullTitle: 'Automated Campaigns Generation - Phase 4',
    icon: 'looks_4',
    titleIcon: true,
    path: '/acg/phase-4',
  },
];

export default acgRoutes;
